<div class="p-col-3 app_printButton__container print_hide-on-print" (click)="print()">
  <span
    ><i
      class="pi pi-print"
      style="font-size: 0.9rem; margin-right: 10px;"
    ></i
  ></span>
  Imprimir examen
</div>
